import Home from "./pages/Home";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import WorkEx from "./pages/WorkEx";
import Navbar from "./layout/Navbar";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";

function App() {
  return (
    <>
    <Router >
      <Navbar />
      <main className='container mx-auto px-3 pb-12'>
        <Routes>
          <Route path='/' element={<Home />}/>
          <Route path='/projects' element={<Projects />}/>
          <Route path='/work-experience' element={<WorkEx/>}/>
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </main>
    </Router>
    
    </>
  );
}

export default App;
